// extracted by mini-css-extract-plugin
export var col = "style-module--col--79675";
export var desc = "style-module--desc--484a4";
export var img = "style-module--img--83f93";
export var info = "style-module--info--a02ef";